import React, { useRef, useState } from 'react';
import { Card, Button, Typography, QRCode } from 'antd';
import { useTranslation } from 'react-i18next';
import { DownloadOutlined } from '@ant-design/icons';

const { Title } = Typography;

interface QRCodeCardProps {
  value: string;
  title?: string;
}

const QRCodeCard: React.FC<QRCodeCardProps> = ({ value, title }) => {
  const [hovered, setHovered] = useState(false);
  const { t } = useTranslation();
  const qrRef = useRef<HTMLDivElement>(null);

  const handleDownload = () => {
    const qrCanvas = qrRef.current?.querySelector('canvas');
    if (qrCanvas) {
      const link = document.createElement('a');
      link.download = `qr-code-${Date.now()}.png`;
      link.href = qrCanvas.toDataURL();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <div className="text-center">
      {title && <Title level={4}>{title}</Title>}
      <div
        ref={qrRef}
        style={{
          position: 'relative',
          display: 'inline-block',
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <QRCode value={value} size={200} includeMargin />
        {hovered && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.27)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 4,
            }}
          >
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              size="small"
              onClick={handleDownload}
            >
              {t('common.download')}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default QRCodeCard;
